import { render, staticRenderFns } from "./GreenUnderlineText.vue?vue&type=template&id=7b806732&scoped=true&"
import script from "./GreenUnderlineText.vue?vue&type=script&lang=ts&"
export * from "./GreenUnderlineText.vue?vue&type=script&lang=ts&"
import style0 from "./GreenUnderlineText.vue?vue&type=style&index=0&id=7b806732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b806732",
  null
  
)

export default component.exports